var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "white",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__money"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector__x28_Stroke_x29_",
    d: "M11.072,11.5c0.663-0.664,1.562-1.036,2.5-1.036c0.937,0,1.837,0.372,2.499,1.036 c0.664,0.663,1.037,1.563,1.037,2.5c0,0.938-0.373,1.837-1.037,2.5c-0.662,0.663-1.563,1.036-2.499,1.036 c-0.938,0-1.838-0.373-2.5-1.036c-0.664-0.663-1.036-1.562-1.036-2.5C10.036,13.063,10.408,12.163,11.072,11.5z M13.572,12.821 c-0.313,0-0.612,0.124-0.835,0.346c-0.22,0.221-0.344,0.521-0.344,0.833c0,0.313,0.125,0.612,0.344,0.833 c0.223,0.222,0.521,0.346,0.835,0.346c0.313,0,0.612-0.124,0.832-0.346c0.223-0.221,0.346-0.52,0.346-0.833 c0-0.313-0.123-0.612-0.346-0.833C14.185,12.945,13.885,12.821,13.572,12.821z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4475__x28_Stroke_x29_",
    d: "M4.142,6.929H23v14.144H4.142V6.929z M6.499,9.286v9.428h14.144V9.286H6.499z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45__x28_Stroke_x29_",
    d: "M1,3.785h17.679v2.357H3.356v9.821H1V3.785z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.dfc9458aee3175592e1b500ab95bf071.svg";
export { ForwardRef as ReactComponent };